import { render, staticRenderFns } from "./bottomPage.vue?vue&type=template&id=6963552b&scoped=true"
import script from "./bottomPage.vue?vue&type=script&lang=js"
export * from "./bottomPage.vue?vue&type=script&lang=js"
import style0 from "./bottomPage.vue?vue&type=style&index=0&id=6963552b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6963552b",
  null
  
)

export default component.exports